import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useNavigationState = () => {
    const [isNavigating, setIsNavigating] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Set navigating to true when route changes
        setIsNavigating(true);

        // Reset navigating state after a short delay
        const timer = setTimeout(() => {
            setIsNavigating(false);
        }, 200);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    return isNavigating;
};
